export default {
  setOnboardingMobileWelcomeModal(state, payload) {
    state.onboardingMobile.welcomeModal = payload;
  },
  setOnboardingMobileAttendance(state, payload) {
    state.onboardingMobile.attendance = payload;
  },
  setOnboardingMobileHomework(state, payload) {
    state.onboardingMobile.homework = payload;
  },
  setOnboardingMobileSingleHomework(state, payload) {
    state.onboardingMobile.singleHomework = payload;
  },
  setOnboardingMobileGrades(state, payload) {
    state.onboardingMobile.grades = payload;
  },
  setOnboardingDesktopWelcomeModal(state, payload) {
    state.onboardingDesktop.welcomeModal = payload;
  },
  setOnboardingDesktopAttendance(state, payload) {
    state.onboardingDesktop.attendance = payload;
  },
  setOnboardingDesktopHomework(state, payload) {
    state.onboardingDesktop.homework = payload;
  },
  setOnboardingDesktopSingleHomework(state, payload) {
    state.onboardingDesktop.singleHomework = payload;
  },
  setOnboardingDesktopGrades(state, payload) {
    state.onboardingDesktop.grades = payload;
  },
};
